export default __webpack_public_path__ + "static/right-pixi-012940a2ecf416561ed3ee2c100e7e80.png";